module.exports = __webpack_public_path__ + "img/logo_web.ecbbd3d4.png";